import { __assign } from "tslib";
import * as React from 'react';
import { SvgIcon, IconPropTypes } from '../SvgIcon';
export function createSvg(path, viewBox, name) {
    var Icon = function (props) { return (React.createElement(SvgIcon, __assign({ viewBox: viewBox }, props), path)); };
    Icon.displayName = name;
    // @ts-ignore
    Icon.propTypes = IconPropTypes;
    return Icon;
}
//# sourceMappingURL=createSvg.js.map